import React, { useEffect, useState } from "react";
import { Form, Checkbox, TimePicker, Row, Col, Card } from "antd";
import { useWatch } from "antd/es/form/Form";
import moment from "moment-timezone";
import Text from "antd/lib/typography/Text";


const { RangePicker } = TimePicker;
const diasSemana = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const HoursEditor = ({ form, name = "horario" }) => {
  const [enabled, setEnabled] = useState(false);
  const [dayActive, setDayActive] = useState({});
  const horarioValues = useWatch(name, form);
  useEffect(() => {
    let data = form.getFieldValue(name) || {};
    setEnabled(data.enabled || false);

    const activos = {};
    diasSemana.forEach((dia) => {
        if(data.dias?.[dia]){
            if (data.dias?.[dia][0] && data.dias?.[dia][1]) {
                activos[dia] = true;
            } 
            else {
                activos[dia] = false;
            }
        }
    });
    setDayActive(activos);
  }, [horarioValues]);


  const toggleDia = (dia, checked) => {
    setDayActive((prev) => ({ ...prev, [dia]: checked }));

    const current = form.getFieldValue(name) || {};
    const dias = current.dias || {};

    // Si se activa y no hay horario aún, asigna 08:00 a 17:00
    if (checked && (!dias[dia] || dias[dia].length !== 2)) {
        dias[dia] = [moment("08:00", "hh:mm"), moment("17:00", "hh:mm")];
        form.setFieldsValue({
            [name]: {
                ...current,
                dias
            }
        });
    }

    // Si se desactiva, elimina las horas
    if (!checked) {
        dias[dia] = null;
        form.setFieldsValue({
            [name]: {
                ...current,
                dias
            }
        });
    }
  };

  const validateRange = (_, value) => {
    if (!value || value.length !== 2) {
      return Promise.reject("Debe ingresar un horario válido");
    }
  
    const [start, end] = value;
  
    if (!start || !end) {
      return Promise.reject("Ambos campos son requeridos");
    }
  
    if (start.isSame(end)) {
      return Promise.reject("La hora de inicio y fin no pueden ser iguales");
    }
  
    if (start.isAfter(end)) {
      return Promise.reject("No se permiten horarios nocturnos (inicio debe ser antes que fin)");
    }
  
    return Promise.resolve();
  };

  return (
    <Card title="Horario de acceso por día">
      <Form.Item name={[name, "enabled"]} valuePropName="checked">
        <Checkbox onChange={(e) => setEnabled(e.target.checked)}>Habilitar restricción de horario</Checkbox>
      </Form.Item>

      {!enabled && (
        <Text type="secondary">
          La restricción horaria está <strong>desactivada</strong>. El usuario
          podrá acceder en cualquier momento.
        </Text>
      )}

      {enabled && (
        <>
            { diasSemana.map((dia) => (
                <Row key={dia} gutter={16} align="middle" style={{ marginBottom: 12 }}>
                <Col span={6}>
                    <Checkbox
                        checked={dayActive[dia]}
                        onChange={(e) => toggleDia(dia, e.target.checked)}
                    >
                        <strong style={{ textTransform: "capitalize" }}>{dia}</strong>
                    </Checkbox>
                </Col>
                <Col span={16}>
                <Form.Item
                        name={[name, "dias", dia]}
                        rules={[
                        {
                            required: dayActive[dia],
                            message: "Debe seleccionar el rango de horario",
                            validator: dayActive[dia] ? validateRange : undefined
                        },
                        ]}
                        style={{marginBottom: 0}}
                    >
                        <RangePicker
                        format="HH:mm"
                        minuteStep={15}
                        disabled={!dayActive[dia]}
                        />
                    </Form.Item>
                </Col>
                </Row>
            )) }
        </>
      )}
    </Card>
  );
};

export default HoursEditor;